import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { dashboardActions, DashboardData, dashboardSelectors } from '../../../ducks/dashboard';
import { AppDispatch } from '../../../store';

export const useDashboardPage = () => {
  const dispatch = useDispatch<AppDispatch>();

  const dashboardData = useSelector(dashboardSelectors.data);

  useEffect(() => {
    dispatch(dashboardActions.fetchDashboardData.started({}));
  }, [dispatch]);

  // useEffect(() => {
  //   fetch('/mock/dashboard.json')
  //     .then((res) => {
  //       if (!res.ok) throw new Error('Failed to fetch dashboard data');
  //       return res.json();
  //     })
  //     .then(setData)
  //     .catch((err) => setError(err.message))
  //     .finally(() => setLoading(false));
  // }, []);

  return { dashboardData };
}